import { createSelector } from "@ngrx/store";

import * as fromRoot from "../../../../core/router-store";
import * as fromFeature from "../reducers";
import * as fromStudents from "../reducers/students.reducer";
import * as selectorsHelperFn from "#helpers/selectors.helper";
import { Student } from "cli-types";

// get students state
export const getStudentsState = createSelector(
    fromFeature.getCoursesModuleState,
    (state: fromFeature.CoursesState) => state.students
);

// get student entities
export const getStudentsEntities = createSelector(
    getStudentsState,
    fromStudents.getStudentsEntities
);

// get individual student
export const getSelectedStudent = createSelector(
    getStudentsEntities,
    fromRoot.getRouterState,
    (entities, router): Student | null => {
        return selectorsHelperFn.getSelectedEntity<Student>(
            entities,
            router,
            "userID"
        );
    }
);

// convert Entities so view can consume
export const getAllStudents = createSelector(getStudentsEntities, entities => {
    return Array.from(entities.values());
});

export const getStudentMetrics = createSelector(
    getStudentsState,
    fromStudents.getStudentMetrics
);

export const getStudentsLoaded = createSelector(
    getStudentsState,
    fromStudents.getStudentsLoaded
);

export const getStudentsLoading = createSelector(
    getStudentsState,
    fromStudents.getStudentsLoading
);

export const getStudentsRawResponse = createSelector(
    getStudentsState,
    fromStudents.getStudentsRawResponse
);

export const getStudentsPaginationParams = createSelector(
    getStudentsState,
    fromStudents.getStudentsPaginationParams
);

export const getStudentFilterBoxOpened = createSelector(
    getStudentsState,
    fromStudents.getStudentFilterBoxOpened
);

export const getFidoStudentsData = createSelector(
    getStudentsState,
    fromStudents.getFidoStudentsData
);
